import * as R from 'ramda'

import * as actionTypes from 'store/actionTypes/session'

export const setSession = R.assoc('session', R.__, { type: actionTypes.SET_SESSION })
export const clearSession = () => ({ type: actionTypes.CLEAR_SESSION })
